module.exports = __webpack_public_path__ + "faccff14a64c110c16eb782607b314db.svg";